<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Simpangan Baku
      </CCardHeader>
      <CCardBody>
        <div class="form-group" v-bind:class="{'error': errors.major_id}">
          <label>Jurusan SMA</label>
          <entrance-major v-model="data.entrance_major" />
          <message-container :data="errors.major_id" />
        </div>
        <div class="form-group" v-bind:class="{'error': errors.subject_id}">
          <label>Mata Pelajaran</label>
          <subject-selector v-model="data.subject" />
          <message-container :data="errors.subject_id" />
        </div>
        <div class="form-group" v-bind:class="{'error': errors.year}">
          <label>Tahun</label>
          <year-selector v-model="data.year" />
          <message-container :data="errors.year" />
        </div>
        <div class="form-group" v-bind:class="{'error': errors.average}">
          <label>Rata-rata</label>
          <input type="number" class="form-control" v-model="data.average" />
          <message-container :data="errors.average" />
        </div>
        <div class="form-group" v-bind:class="{'error': errors.value}">
          <label>Simpangan Baku</label>
          <input type="number" class="form-control" v-model="data.value" />
          <message-container :data="errors.value" />
        </div>
      </CCardBody>
      <CCardFooter>
        <button class="btn btn-success" @click="update" v-show="data.id">Save</button>
        <button class="btn btn-success" @click="save" v-show="!data.id">Save</button>
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import EntranceMajor from "../../components/EntranceMajor"
import YearSelector from "../../components/YearSelector"
import MessageContainer from "../../components/MessageContainer"
import SubjectSelector from "../../components/SubjectSelector"
import { showErrorMessage } from "../../lib/helpers"
import { HTTPAUTH } from "../../lib/httplib"
export default {
  data() {
    return {
      data: {},
      errors: [],
    };
  },
  components: {
    SubjectSelector,
    YearSelector,
    MessageContainer,
    EntranceMajor,
  },
  created() {
    const query = this.$route.params;
    if (query && query.id) {
      this.get(query.id)
    }
  },
  methods: {
    get(id) {
      if (id == 'new') {
        return;
      }
      HTTPAUTH.get(`/api/v1/admin/mapping/standard-deviation/${id}`, this.data)
        .then((res) => {
          this.data = res.data.data;
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    save() {
      if (this.data.subject) {
        this.data.subject_id = this.data.subject.id;
      }
      if (this.data.entrance_major) {
        this.data.entrance_major_id = this.data.entrance_major.id;
      }
      if (this.data.year) {
        this.data.year = this.data.year.label;
      }
      HTTPAUTH.post(`/api/v1/admin/mapping/standard-deviation`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil disimpan").goAway();
        })
        .catch((eres) => {
          this.data.year = {
            label: this.data.year,
          };
          this.errors = showErrorMessage(eres);
        });
    },
    update() {
      if (this.data.subject) {
        this.data.subject_id = this.data.subject.id;
      }
      if (this.data.entrance_major) {
        this.data.entrance_major_id = this.data.entrance_major.id;
      }
      if (this.data.year) {
        this.data.year = this.data.year.label;
      }
      HTTPAUTH.put(`/api/v1/admin/mapping/standard-deviation/${this.data.id}`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil disimpan").goAway();
          this.$router.push({path: "/mapping/standard-deviation"})
        })
        .catch((eres) => {
          this.errors = showErrorMessage(eres);
        });
    },
  },
};
</script>